import Butter from 'buttercms'
const butter = Butter('cb88af926710de8123ff86eee7d2400d94036ebd')
export default butter